export default __webpack_public_path__ + "static/media/IntegrationSlack.8406a431.jpg";